import { render, staticRenderFns } from "./ordenar_colecciones.vue?vue&type=template&id=d4530426&"
import script from "./ordenar_colecciones.vue?vue&type=script&lang=js&"
export * from "./ordenar_colecciones.vue?vue&type=script&lang=js&"
import style0 from "./ordenar_colecciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports